import { Component, input, output, viewChildren } from '@angular/core';
import { Element } from '../element/element';
import {
  ComposedPage,
  InteractionTypes,
} from '@hyper-inferno/survey-elements-core-utils';

@Component({
  selector: 'lib-page',
  imports: [Element],
  templateUrl: './page.html',
  styleUrl: './page.css',
})
export class Page {
  pageAction = output<{ type: InteractionTypes; payload?: any }>();

  onJump(event: Event) {
    const selectElement = event.target as HTMLSelectElement;
    const questionId = selectElement.value;
    if (questionId) {
      this.pageAction.emit({
        type: InteractionTypes.CUSTOM_SWITCH,
        payload: { questionId },
      });
    }
  }

  // Function called by the "Next" button
  onNextClick() {
    this.pageAction.emit({ type: InteractionTypes.SUBMIT });
  }
  goForward() {
    this.pageAction.emit({ type: InteractionTypes.SUBMIT });
  }
  goBack() {
    this.pageAction.emit({ type: InteractionTypes.SWITCH, payload: false });
  }
  page = input.required<ComposedPage>();
  isValid = input.required<boolean>();

  private elementRefs = viewChildren(Element);
  onSubmit() {}
}
